<template>
  <div ref="tableRootRef">
    <div class="btn-container clearfix">
      <div class="left-opt fl">
        <el-button
          v-permission="{ pkey: `${permissionName}_ADD` }"
          class="filter-item"
          type="primary"
          :size="t('table.btnSize')"
          @click="handleCommand('add')"
          v-if="canAdd"
        >
          {{ t("table.add") }}
        </el-button>
        <slot name="left-buttons"/>
      </div>
      <div class="rigth-opt fr">
        <slot name="right-buttons"/>
        <span class="svg-icon cursor mr-10" @click="handleCommand('refresh')" v-if="canRefresh">
          <i class="icon-tubiao-27 iconfont"/>
        </span>
        <span class="svg-icon cursor" @click="handleSetColumnVisible" v-if="canChangeColumn">
          <i class="icon-tubiao-28 iconfont"/>
        </span>
      </div>
    </div>
    <el-table
      ref="elTableRef"
      v-loading="loading"
      :data="dataList"
      border
      fit
      :stripe='isStripe'
      row-key="id"
      style="width: 100%"
      :max-height="tableMaxHegiht"
      :highlight-current-row="highlightCurrentRow"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
      :row-class-name="tableRowClassName"
      :summary-method="getSummaries"
      :show-summary="showSummary"
      :span-method="objectSpanMethod"
      @row-click="handleRowChange"
      @selection-change="handleSelectionChange"
      @header-dragend="handleHeaderDragend"
    >
      <el-table-column type="selection" :width="showSummary ? 60 : 45" v-if="showSelection" fixed="left"/>
      <el-table-column type="index" :width="60" v-if="showIndex" label="序列号"/>
      <el-table-column
        v-for="(column, index) of columnData"
        :min-width="customColumnWidth(column)"
        :width="column.width || ''"
        :key="`${getColIdentity(column)}_${index}`"
        :prop="JSON.stringify(column)"
        :label="column.fieldName"
        show-overflow-tooltip
        :align="column.textAlign || 'left'"
      >
        <template #default="{ row, $index }">
          <template v-if="!(row.editable ?? row.isEidt)">
            <slot :name="column.fieldKey" v-bind="{ row, $index }">
               <!--优先使用convert function-->
              <template v-if="column.convert">
                <div v-if="column.html" v-html="getConvertValue(column, row, $index, index)" ></div>
                <span v-else>{{getConvertValue(column, row, $index, index)}}</span>
              </template>
              <!-- 通用类型格式化器 / 自定义 formatter -->
              <template v-else-if="column.formatter || column.formatType || column.isMoney">
                <span>{{ getFormattedCell(column, row, $index) }}</span>
              </template>
              <template v-else>
                <template v-if="column.componentType === 'el-upload'">
                  <ZPreview :authSrc="row[column.fieldKey]" :width="'auto'" :height="'.533333rem'" :isEdit="false"/>
                </template>
                <template v-else-if="column.componentType === 'el-iconfont'">
                  <i class="iconfont " :class="getColumnValue(column, row)"></i>
                </template>
                <template v-else-if="column.componentType === 'el-array'">
                  <span>
                    {{column.formatValue && column.formatValue(row)}}
                  </span>
                </template>
                <template v-else>
                  <span :class="{ 'cell-red': isChanged(column, row) }">
                    <el-tooltip
                      effect="dark"
                      :content="getDiffTip(column, row)"
                      placement="top-start"
                      v-if="isChanged(column, row)"
                    >
                      <i class="iconfont icon-tubiao-40 cell-blue" ></i>
                    </el-tooltip>
                    {{getColumnValue(column, row) }}
                  </span>
                </template>
              </template>
            </slot>
          </template>
          <template v-else>
            <div v-for="(fields, index) in (row.editForm ?? row.eidtForm)" :key="index">
              <FromField :fields="fields" :team-change="handleEditChange(fields)" :id="row.id || 0" v-if="column.fieldKey === fields.fieldKey"/>
            </div>
          </template>
        </template>
      </el-table-column>

      <el-table-column
        v-if="canCommand"
        label="操作"
        align="center"
        :min-width="handleDefaultWidth"
        fixed="right"
      >
        <template #default="{ row, $index }">
          <slot name="operation-action" v-bind="{ row, $index }" />
        </template>
      </el-table-column>
    </el-table>
    <template v-if="isShowPagination">
      <el-pagination
        class="mt-20"
        :total="ttotal"
        :currentPage="tpage"
        :page-size="tsize"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </template>
    <el-dialog
      v-model="setColumnVisible"
      title="选择列表显示数据"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :before-close="handleSetColumnClose"
      destroy-on-close
    >
    <el-checkbox-group v-model="columnCheckList" class="columnSet">
      <draggable
        :list="tabelField"
        :itemKey="getColIdentity"
        ghost-class="ghost"
        chosen-class="chosenClass"
        animation="300"
        @end="handleDraggleEnd">
        <template #item="{ element }">
          <el-checkbox :value="getColIdentity(element)" :label="element.fieldName" />
        </template>
      </draggable>
    </el-checkbox-group>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleResetColumn">恢复默认</el-button>
        <el-button @click="handleSetColumnClose" type="danger">取消</el-button>
        <el-button type="primary" @click="handleSetColumn">确定</el-button>
      </span>
    </template>
  </el-dialog>
  </div>
</template>
<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, onBeforeUnmount, onActivated, nextTick, ref, PropType, watch, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

import { tableSetting, getTableColumnList } from '@/apis/tool'
import { TableFieldConvertContext, TableFieldModel } from '@/model/TableList'
// import { ArrayRowsItem } from '@/model/Index'
import ZPreview from '@/components/common/ZPreview.vue'
import FromField from '@/components/common/FormField.vue'
import draggable from 'vuedraggable'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils'
import { formatCurrency, formatTaxRate, formatBoolean, formatDate } from '@/utils/formatters'
import $number from 'number-precision'
import $currency from 'currency.js'

export default defineComponent({
  name: 'TableList',
  components: {
    ZPreview,
    FromField,
    draggable
  },
  props: {
    editable: { type: Boolean, required: false, default: false },
    isEidt: { type: Boolean, required: false, default: false },
    total: { type: Number, required: false, default: 0 },
    isShowPagination: { type: Boolean, required: false, default: true },
    dataList: { type: Array, required: true, default: () => [] },
    tableName: { type: String, required: false },
    permissionName: { type: String, required: false, default: '' },
    page: { type: Number, required: false, default: 1 },
    size: { type: Number, required: false, default: 20 },
    columnAllData: { type: Array as PropType<Array<TableFieldModel>>, required: true },
    lazy: { type: Boolean, required: false, default: false },
    canAdd: { type: Boolean, required: false, default: false },
    canRefresh: { type: Boolean, required: false, default: false },
    canChangeColumn: { type: Boolean, required: false, default: false },
    canCommand: { type: Boolean, required: false, default: true },
    pageSizes: { type: Array, required: false, default: () => [10, 20, 50, 100, 200, 500] },
    showSelection: { type: Boolean, required: false, default: false },
    handleDefaultWidth: { type: Number, required: false, default: 140 },
    highlightCurrentRow: { type: Boolean, required: false, default: true },
    maxHight: { type: [Number, String], required: false, default: 'auto' },
    layoutHeight: { type: Boolean, required: false, default: false },
    newHpx: { type: [Number], required: false, default: 0 },
    tableRowClassName: { type: Function, required: false, default: () => '' },
    showSummary: { type: Boolean, required: false, default: false },
    megreColumn: { type: Array, required: false, default: () => [] },
    isStripe: { type: Boolean, required: false, default: true },
    showIndex: { type: Boolean, required: false, default: false }
  },
  emits: ['command-change', 'load-lazy', 'row-click'],
  setup(props, context) {
    // console.log(useSlots().action, 'operation-action')
    const { t } = useI18n()
    const elTableRef = ref<any>(null)
    const getColIdentity = (col: any): string => `${col?.fieldKey ?? ''}__${col?.fieldName ?? ''}`

    const tableData = reactive({
      tableHeight: 'calc(100vh - 160px)',
      loading: false,
      setColumnVisible: false,
      columnCheckList: [] as string[],
      oldColumnCheckList: [] as string[],
      oldTabelField: [] as any[],
      tabelField: props.columnAllData as any[],
      columnData: [] as any[],
      tableMaxHegiht: 'auto',
      tpage: props.page,
      tsize: props.size,
      ttotal: props.total,
      getColIdentity,
      handleCommand(command: string, val?: any) {
        context.emit('command-change', command, val)
      },
      handleSetColumn() {
        if (!tableData.columnCheckList.length) {
          ElMessage.error('必须选择一项！')
          return
        }
        const tempArr = tableData.tabelField.map((item: any) => {
          const isCheck =
            tableData.columnCheckList.includes(getColIdentity(item)) ||
            tableData.columnCheckList.includes(item.fieldName)
          return { ...item, isCheck }
        })

        if (!props.tableName) {
          tableData.tabelField = tempArr
          tableData.columnData = tempArr.filter((item: any) => item.isCheck)
          tableData.setColumnVisible = false
          nextTick(() => {
            elTableRef.value?.doLayout?.()
          })
          return
        }

        tableSetting({
          tableName: props.tableName,
          fields: tempArr
        }).then(() => {
          tableData.setColumnVisible = false
          ElMessage.success('设置成功！')
          tableData.loadData()
        }).catch(() => {
          ElMessage.error('设置失败！')
        })
      },
      handleResetColumn() {
        const defaultFields = props.columnAllData.map((item: any) => ({
          ...item,
          isCheck: true,
          width: item.width
        }))
        tableData.tabelField = defaultFields
        tableData.columnCheckList = defaultFields.map((item: any) => getColIdentity(item))
        if (!props.tableName) {
          tableData.columnData = defaultFields
          tableData.setColumnVisible = false
          ElMessage.success('已恢复默认列设置！')
          nextTick(() => {
            elTableRef.value?.doLayout?.()
          })
          return
        }
        tableSetting({
          tableName: props.tableName,
          fields: defaultFields
        }).then(() => {
          tableData.setColumnVisible = false
          ElMessage.success('已恢复默认列设置！')
          tableData.loadData()
        }).catch(() => {
          ElMessage.error('恢复默认失败！')
        })
      },
      handleSetColumnVisible() {
        tableData.setColumnVisible = true
      },
      handleSetColumnClose() {
        tableData.columnCheckList = [...tableData.oldColumnCheckList]
        if (tableData.oldTabelField && tableData.oldTabelField.length) {
          tableData.tabelField = tableData.oldTabelField.map((item: any) => ({ ...item }))
        }
        tableData.setColumnVisible = false
      },
      handleCurrentChange(page?: any) {
        tableData.handleCommand('current-change', page)
      },
      handleSizeChange(size: any) {
        tableData.handleCommand('size-change', size)
      },
      customColumnWidth(column: any) {
        let width = 200
        switch (column.componentType) {
          case 'el-rich':
          case 'el-text':
          case 'el-textarea':
          case 'el-upload':
            width = 180
            break
          case 'el-text-number':
            width = 150
            break
          case 'el-date-picker':
          case 'el-date-range-picker':
          case 'el-time-picker':
            width = 160
            break
          case 'el-radio':
          case 'el-checkbox':
          case 'el-select':
          case 'el-cascader':
            width = 160
            break
          case 'el-iconfont':
            width = 80
        }
        return width
      },
      getConvertValue(column: TableFieldModel, rowData: any, rowNumber: number, filedNumber: number): any {
        const convertContext: TableFieldConvertContext = {
          filedModel: column,
          rowData,
          rowNumber,
          filedNumber
        }
        return column.convert ? column.convert(convertContext) : ''
      },
      getColumnValue(column: any, rowData: any) {
        if (column.componentType === 'el-select') {
          const _value = rowData[column.fieldKey]
          const sourceCol = props.columnAllData.find(
            (c: any) => getColIdentity(c) === getColIdentity(column) || c.fieldKey === column.fieldKey
          )
          const optionList = (column.option && column.option.length) ? column.option : sourceCol?.option
          if (optionList && (_value || _value === 0)) {
            const _obj = optionList.find((k: any) => k.id === _value)
            return _obj ? _obj.name : ''
          }
          return rowData[column.fieldKey]
        } else {
          return rowData[column.fieldKey]
        }
      },
      getFormattedCell(column: TableFieldModel, rowData: any, index: number): any {
        if (column.formatter) {
          return column.formatter(rowData, column, index)
        }
        if (column.formatType === 'currency' || column.isMoney) {
          return formatCurrency(rowData[column.fieldKey])
        }
        if (column.formatType === 'percent') {
          return formatTaxRate(rowData[column.fieldKey])
        }
        if (column.formatType === 'boolean') {
          return formatBoolean(rowData[column.fieldKey])
        }
        if (column.formatType === 'date') {
          return formatDate(rowData[column.fieldKey])
        }
        return rowData[column.fieldKey]
      },
      isChanged(column: any, rowData: any) {
        if (!rowData) return false
        if (rowData.fieldDiffs) {
          return Object.keys(rowData.fieldDiffs).includes(column.fieldKey)
        }
        if (rowData.invoiceChanged) {
          return Object.keys(rowData.invoiceChanged).includes(column.fieldKey)
        }
        return false
      },
      getDiffTip(column: any, rowData: any) {
        if (!rowData) return ''
        if (rowData.fieldDiffs && rowData.fieldDiffs[column.fieldKey]) {
          return rowData.fieldDiffs[column.fieldKey]
        }
        if (rowData.invoiceChanged && rowData.invoiceChanged[column.fieldKey]) {
          return rowData.invoiceChanged[column.fieldKey]
        }
        return ''
      },

      loadData() {
        if (!props.tableName) {
          tableData.tabelField = props.columnAllData.map((item: any) => ({ ...item, isCheck: true }))
          tableData.columnData = tableData.tabelField
          tableData.columnCheckList = tableData.columnData.map((item: any) => getColIdentity(item))
          return
        }
        tableData.loading = true
        getTableColumnList(props.tableName).then((res: any) => {
          const requestData = (res && Array.isArray(res.fields) && res.fields.length) ? res.fields : []

          if (requestData.length) {
            const orderedFields: any[] = []
            const usedLocalIndices = new Set<number>()

            requestData.forEach((remoteField: any) => {
              let localIdx = -1
              if (typeof remoteField === 'object' && remoteField !== null) {
                // 1. 优先精确匹配 fieldKey + fieldName
                localIdx = props.columnAllData.findIndex(
                  (col: any, idx: number) =>
                    !usedLocalIndices.has(idx) &&
                    col.fieldKey === remoteField.fieldKey &&
                    col.fieldName === remoteField.fieldName
                )
                // 2. 若列名发生过调整，回退按 fieldKey 匹配
                if (localIdx === -1 && remoteField.fieldKey) {
                  localIdx = props.columnAllData.findIndex(
                    (col: any, idx: number) =>
                      !usedLocalIndices.has(idx) &&
                      col.fieldKey === remoteField.fieldKey
                  )
                }
              } else if (typeof remoteField === 'string') {
                // 兼容历史仅存储字符串列名的结构
                localIdx = props.columnAllData.findIndex(
                  (col: any, idx: number) =>
                    !usedLocalIndices.has(idx) &&
                    (col.fieldName === remoteField || col.fieldKey === remoteField)
                )
              }

              if (localIdx !== -1) {
                usedLocalIndices.add(localIdx)
                const localCol = props.columnAllData[localIdx]
                orderedFields.push({
                  ...localCol,
                  isCheck: typeof remoteField === 'object' ? remoteField.isCheck !== false : true,
                  width: (typeof remoteField === 'object' ? remoteField.width : 0) || localCol.width
                })
              }
            })

            // 3. 将代码中后续新增、但不在已保存列表中的列默认勾选追加在末尾
            props.columnAllData.forEach((localCol: any, idx: number) => {
              if (!usedLocalIndices.has(idx)) {
                orderedFields.push({
                  ...localCol,
                  isCheck: true,
                  width: localCol.width
                })
              }
            })

            tableData.tabelField = orderedFields
          } else {
            tableData.tabelField = props.columnAllData.map((item: any) => ({
              ...item,
              isCheck: true,
              width: item.width
            }))
          }

          const checkFieldData = tableData.tabelField.filter((item: any) => item.isCheck)
          tableData.columnData = checkFieldData
          tableData.columnCheckList = checkFieldData.map((item: any) => getColIdentity(item))

          tableData.loading = false
          nextTick(() => {
            elTableRef.value?.doLayout?.()
          })
        }).catch((error) => {
          console.log(error, 'error')
          tableData.loading = false
          tableData.tabelField = props.columnAllData.map((item: any) => ({ ...item, isCheck: true }))
          tableData.columnData = tableData.tabelField
          tableData.columnCheckList = tableData.columnData.map((item: any) => getColIdentity(item))
        })
      },
      handleRowChange(row: any, column: any, event: any) {
        context.emit('row-click', row, column, event)
      },
      handleSelectionChange(val: any) {
        context.emit('command-change', 'selection', val)
      },
      handleHeaderDragend(newWidth: any, oldWidth: any, column: any) {
        const parsedProp = column.property ? JSON.parse(column.property) : {}
        const targetIdentity = getColIdentity(parsedProp)
        tableData.columnData = tableData.columnData.map((item: any) => {
          const isTarget = getColIdentity(item) === targetIdentity || (item.fieldKey === parsedProp?.fieldKey && item.fieldName === parsedProp?.fieldName)
          const width = isTarget ? newWidth : item.width
          return {
            ...item,
            width
          }
        })
        tableData.tabelField = tableData.tabelField.map((item: any) => {
          const isTarget = getColIdentity(item) === targetIdentity || (item.fieldKey === parsedProp?.fieldKey && item.fieldName === parsedProp?.fieldName)
          const width = isTarget ? newWidth : item.width
          return {
            ...item,
            width
          }
        })
        if (props.tableName) {
          tableSetting({ tableName: props.tableName, fields: tableData.tabelField })
        }
      },
      handleEditChange() {
        console.log(3333)
      },
      handleEidtChange() {
        return this.handleEditChange()
      },
      getDiffHegiht() {
        if (props.canAdd && props.canRefresh && props.canChangeColumn) {
          return 58
        }
        return 0
      },
      handleDraggleEnd() {
        console.log('结束拖拽', tableData.tabelField)
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),

      priceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => priceWithoutRate(price, isCurrency, rate),

      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => totalPriceWithoutRate(price, amount, isCurrency, rate),

      getSummaries(param: any) {
        const { columns, data } = param
        const sums: string[] = []

        // 货币与财务总额字段白名单 (仅保留具有真实财务累加意义的交易总额、费用、收付款等指标)
        const CURRENCY_FIELD_WHITELIST = [
          'totalPrice', 'totalPriceWithRate', 'received', 'receivedAmount', 'remainAmount',
          'paidAmount', 'paid', 'amountFee', 'invoiceAmount', 'invoices-invoiceAmount',
          'orderFeeTotal', 'outCost', 'partsCost', 'marketCost', 'orderFee3', 'orderFee4',
          'orderFee5', 'orderFeeTotalAfterTax', 'outsourceCostWithoutTax', 'partsCostWithoutTax',
          'receivedFee', 'invoicedFee', 'receivedCommission', 'invoiceCommission',
          'businessAmount', 'fee', 'feeWithoutRate', 'total', 'price', 'price1',
          'ticketAmount', 'invoicedAmount', 'paymentPay', 'refundApplyAmount',
          'returnAmount', 'payAmount'
        ]

        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }

          const property = column.property ? JSON.parse(column.property) : {}
          const columnModel = tableData.columnData?.find((col: any) => col.fieldKey === property.fieldKey) || property
          const fieldName = columnModel.fieldName || ''
          const fieldKey = property.fieldKey || ''

          // 1. 一票否决排除守卫 (Hard Exclusion Guard):
          // 含有"单价"、"数量"、"率"、"折扣"、"系数"、"天数"等非累加型度量，或者明确属于单价/数量字段 Key 的列，绝对不统计求和
          const isNonAdditive = Boolean(
            columnModel.formatType === 'percent' ||
            fieldName.includes('单价') ||
            fieldName.includes('数量') ||
            fieldName.includes('率') ||
            fieldName.includes('折扣') ||
            fieldName.includes('系数') ||
            fieldName.includes('天数') ||
            fieldKey === 'orderFee' ||
            fieldKey === 'orderFee2' ||
            fieldKey === 'unitPrice' ||
            fieldKey === 'taxRate' ||
            fieldKey === 'orderTaxRate' ||
            fieldKey === 'num' ||
            (fieldKey === 'amount' && !columnModel.isMoney && !fieldName.includes('金额') && !fieldName.includes('费用'))
          )

          if (isNonAdditive) {
            sums[index] = ''
            return
          }

          // 2. 判断是否为金额/总额列 (语义标注优先 + 白名单兜底)
          const isMoneyCol = Boolean(
            columnModel.isMoney ||
            columnModel.formatType === 'currency' ||
            CURRENCY_FIELD_WHITELIST.includes(fieldKey) ||
            (fieldName && (
              fieldName.includes('金额') ||
              fieldName.includes('费用') ||
              fieldName.includes('成本') ||
              fieldName.includes('总价') ||
              fieldName.includes('总额')
            ))
          )

          if (!isMoneyCol) {
            sums[index] = ''
            return
          }

          const values = data.map((item: any, rowIdx: number) => {
            let val = item[property.fieldKey]
            // 若原始行数据无此数值字段，但该列配置了 convert 计算函数，尝试提取计算后的数值
            if ((val === undefined || val === null || val === '' || Number.isNaN(Number(val))) && columnModel.convert) {
              try {
                const converted = columnModel.convert({
                  filedModel: columnModel,
                  rowData: item,
                  rowNumber: rowIdx,
                  filedNumber: index
                })
                if (typeof converted === 'number') {
                  val = converted
                } else if (typeof converted === 'string') {
                  const cleaned = converted.replace(/[^0-9.-]+/g, '')
                  if (cleaned !== '') {
                    val = Number(cleaned)
                  }
                }
              } catch (e) {
                // ignore convert errors
              }
            }
            return Number(val)
          })

          if (values.every((value: any) => Number.isNaN(value))) {
            sums[index] = ''
            return
          }

          const sumNum = values.reduce((prev: any, curr: any) => {
            if (!Number.isNaN(Number(curr))) {
              return $number.plus(prev, curr)
            }
            return prev
          }, 0)

          sums[index] = $currency(sumNum).toString()
        })
        return sums
      },
      objectSpanMethod({ column, rowIndex }: any) {
        const property = column.property ? JSON.parse(column.property) : {}
        if (props.megreColumn.length && (column.type === 'selection' || props.megreColumn.includes(property.fieldKey))) {
          return {
            rowspan: tableData.spanArrChange.no.spanArr[rowIndex],
            colspan: 1
          }
        } else {
          return { rowspan: 1, colspan: 1 }
        }
      },
      spanArrChange: computed(() => {
        const megre = ['no']
        const data = props.dataList as any
        const spanArr = {} as any
        megre.forEach((m: any) => {
          spanArr[m] = { spanArr: [], pos: 0 }
        })
        data.forEach((row: any, i: number) => {
          megre.forEach(m => {
            if (i === 0) {
              spanArr[m].spanArr.push(1)
              spanArr[m].pos = 0
            } else {
              if (row[m] === data[i - 1][m]) {
                spanArr[m].spanArr[spanArr[m].pos] += 1
                spanArr[m].spanArr.push(0)
              } else {
                spanArr[m].spanArr.push(1)
                spanArr[m].pos = i
              }
            }
          })
        })
        return spanArr
      })
    })

    watch(() => [props.page, props.size, props.total], (val) => {
      tableData.tpage = val[0]
      tableData.tsize = val[1]
      tableData.ttotal = val[2]
    }, { immediate: true })
    watch(() => tableData.setColumnVisible, (val) => {
      if (val) {
        tableData.oldColumnCheckList = [...tableData.columnCheckList]
        tableData.oldTabelField = tableData.tabelField.map((item: any) => ({ ...item }))
      }
    }, { immediate: true })

    watch(() => props.tableName, () => {
      tableData.loadData()
    })

    const tableRootRef = ref<HTMLElement | null>(null)
    let layoutResizeObserver: ResizeObserver | null = null

    const updateTableMaxHeight = () => {
      if (props.newHpx && typeof props.newHpx === 'number' && props.newHpx > 0) {
        ;(tableData.tableMaxHegiht as any) = Math.max(120, props.newHpx - tableData.getDiffHegiht())
        return
      }
      if (!props.layoutHeight && props.maxHight !== 'auto') {
        ;(tableData.tableMaxHegiht as any) = props.maxHight
        return
      }
      const rootEl = tableRootRef.value
      if (!rootEl) {
        return
      }
      if (rootEl.closest('.split-pane-bottom') || rootEl.closest('.el-dialog')) {
        ;(tableData.tableMaxHegiht as any) = props.maxHight
        return
      }
      const rect = rootEl.getBoundingClientRect()
      const viewportRemain = rect.top > 0 ? window.innerHeight - rect.top - 64 - tableData.getDiffHegiht() : 0
      if (props.layoutHeight) {
        const gridItem = rootEl.closest('.vue-grid-item') as HTMLElement | null
        const gridH = gridItem ? gridItem.clientHeight : 0
        if (gridH > 0 && viewportRemain > 150) {
          ;(tableData.tableMaxHegiht as any) = Math.max(150, Math.min(gridH - tableData.getDiffHegiht(), viewportRemain))
        } else if (gridH > 0) {
          ;(tableData.tableMaxHegiht as any) = Math.max(150, gridH - tableData.getDiffHegiht())
        } else if (viewportRemain > 150) {
          ;(tableData.tableMaxHegiht as any) = Math.max(180, viewportRemain)
        }
        return
      }
      if (props.tableName && viewportRemain > 150) {
        ;(tableData.tableMaxHegiht as any) = Math.max(180, viewportRemain)
      }
    }

    watch(() => props.newHpx, () => {
      updateTableMaxHeight()
    }, { immediate: true })

    onMounted(() => {
      tableData.loadData()
      nextTick(() => {
        updateTableMaxHeight()
      })
      window.addEventListener('resize', updateTableMaxHeight)
      if (typeof ResizeObserver !== 'undefined' && tableRootRef.value) {
        layoutResizeObserver = new ResizeObserver(() => {
          updateTableMaxHeight()
        })
        const listContainer = tableRootRef.value.closest('.list-container')
        const filterEl = listContainer?.querySelector('.filter-container')
        const gridItemEl = tableRootRef.value.closest('.vue-grid-item')
        if (filterEl) {
          layoutResizeObserver.observe(filterEl)
        }
        if (gridItemEl) {
          layoutResizeObserver.observe(gridItemEl)
        }
      }
    })

    onActivated(() => {
      setTimeout(() => {
        updateTableMaxHeight()
      }, 60)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateTableMaxHeight)
      if (layoutResizeObserver) {
        layoutResizeObserver.disconnect()
        layoutResizeObserver = null
      }
    })

    return { t, elTableRef, tableRootRef, ...toRefs(tableData) }
  }
})

</script>
<style lang="scss">
.columnSet{
  .el-checkbox{
    // width: 124px;
    margin-right: 20px;
    margin-bottom: 16px;
  }
}
</style>
